
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cars/calculator",
      function () {
        return require("private-next-pages/cars/calculator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cars/calculator"])
      });
    }
  